/**
 * SelectionActionBar — bottom-centre move-to-column bar shown when N cards are selected.
 *
 * Per FWV v8 §30: rendering extracted from TodayView. Pure presentational
 * component; receives the selection state + a move callback from the parent.
 */
import type { DbTask } from '../../db'

export function SelectionActionBar({
  count,
  multiHint,
  columns,
  onMove,
  onClear,
}: {
  count: number
  multiHint: string
  columns: { id: DbTask['status']; label: string }[]
  onMove: (target: DbTask['status']) => void
  onClear: () => void
}) {
  return (
    <div
      data-rubber-band-action
      className="fixed bottom-4 left-1/2 -translate-x-1/2 bg-garden-800 text-white rounded-2xl shadow-xl px-4 py-2 flex items-center gap-2 z-40 text-sm"
    >
      <span className="font-medium">{count} selected</span>
      <span className="text-garden-200">·</span>
      <span className="text-garden-100 text-xs hidden sm:inline">{multiHint}</span>
      {columns.map((col) => (
        <button
          key={col.id}
          onClick={() => onMove(col.id)}
          className="text-xs bg-garden-700 hover:bg-garden-600 text-white rounded px-2 py-1 min-h-touch"
        >
          {col.label}
        </button>
      ))}
      <button
        onClick={onClear}
        className="ml-2 text-garden-100 hover:text-white text-xs underline min-h-touch px-2"
      >
        Clear
      </button>
    </div>
  )
}